import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { ReactComponent as Icon1 } from "../icons/dashboard.svg";
import { ReactComponent as Icon2 } from "../icons/errors.svg";
import { ReactComponent as Icon3 } from "../icons/validation.svg";
import { ReactComponent as Icon6 } from "../icons/grip.svg";
import { ReactComponent as Icon4 } from "../icons/toccompare.svg";
import { ReactComponent as Icon5 } from "../icons/package_creation.svg";
import { ReactComponent as Icon7 } from "../icons/tag.svg";
import { useAuth } from "./Auth/userContext";

const panellist = [
  { title: "Dashboard", icon: <Icon1 />, url: "dashboard" },
  { title: "Package Creation", icon: <Icon5 />, url: "package_creation" },
  {
    title: "ISC Cleaning Process",
    icon: <Icon3 />,
    url: "isc_cleaning_process",
  },
  // { title: "Checklist Errors", icon: <Icon2 />, url: "checklist_errors" },
  // {
  //   title: "Validation Report",
  //   icon: <Icon3 />,
  //   url: "epub_validation_report",
  // },
  // { title: "TOC/NCX Compare", icon: <Icon4 />, url: "toc_vs_ncx_compare" },
  { title: "LaTeX to HTML", icon: <Icon4 />, url: "latex_to_html" },
    { title: "Griplist", icon: <Icon6 />, url: "grip_list" },
    { title: "AutoTag PDF", icon: <Icon7 />, url: "autotag_pdf" },
];

const Leftpanel = ({ leftOpen }) => {
  const [panels, setPanels] = useState([]);
  let { pages } = useParams();
  const navigate = useNavigate();
  let currentpage = pages?.toLowerCase();
  useEffect(() => {
    if (!pages) {
      navigate("/accessibility_epub/dashboard");
    }
  }, []);

  const { user } = useAuth();

  useEffect(() => {
    const userCategory = user?.user_cat;
    // assuming this exists

    switch (userCategory) {
      case "2": // Vendor
        setPanels([panellist[2]]);
        navigate("/accessibility_epub/isc_cleaning_process");
        break;
      case "1": // Admin type 1
      case "0": // Admin type 0
        setPanels([...panellist]);
        navigate("/accessibility_epub/dashboard");
        break;
      default:
        setPanels([]); // or fallback
        break;
    }
  }, [user]);

  // console.log(user);

  return (
    <div
      className="flex flex-col p-8 gap-2 overflow-auto"
      style={{ height: "calc(100vh - 96px)" }}
    >
      {panels.length > 0 &&
        panels?.map((item, i) => (
          <Link
            to={item.url.toLowerCase()}
            key={i}
            className={`${
              leftOpen ? "" : "justify-center"
            } flex gap-3 items-center overflow-hidden w-full cursor-pointer ${
              currentpage === item.url.toLowerCase() ? "bg-selectbg" : "bg-none"
            } ${
              leftOpen ? "px-6 py-[11px] rounded-[16px]" : "p-3 rounded-[12px]"
            }`}
          >
            <div
              className={`flex justify-center items-center ${
                currentpage === item.url.toLowerCase()
                  ? "text-white"
                  : "text-title"
              } `}
            >
              {item.icon}
            </div>
            {leftOpen && (
              <p
                className={`text-18 text-left font-regular ${
                  currentpage === item.url.toLowerCase()
                    ? "text-white"
                    : "text-title"
                }`}
              >
                {item.title}
              </p>
            )}
          </Link>
        ))}
    </div>
  );
};

export default Leftpanel;
